import * as React from 'react'

function CircleCheckmarkIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" {...props}>
      <g data-name="Group 52835">
        <g data-name="Group 51811">
          <g
            data-name="Ellipse 1015"
            transform="translate(-104 -1999.4) translate(104 1999.961) translate(0 -.561)"
            fill="none"
            stroke="#209684"
            strokeWidth={1.8}
          >
            <circle cx={10} cy={10} r={10} stroke="none" />
            <circle cx={10} cy={10} r={9.1} />
          </g>
          <path
            data-name="Path 17746"
            d="M6.554 10.031l-1.363-1.1L6.4 6.96 2 3.315 3.159 2l5.032 4.2a.876.876 0 01.1 1.209z"
            transform="translate(-104 -1999.4) translate(104 1999.961) rotate(90 6.08 10.276)"
            fill="#209684"
          />
        </g>
      </g>
    </svg>
  )
}

export default CircleCheckmarkIcon
